const select = (state, map) => map[state?.language] || map[Object.keys(map)[0]];

export const createHyperlinksModule = () => {
  return {
    state: {},
    getters: {
      hyperlink_downloads_ies3_with_surgical_units: (state, getters, rootState) => {
        return select(rootState, {
          en: "https://www.medical-videos.com/installation-and-operation-of-the-ies-3-smoke-evacuation-system-in-combination-with-electrosurgical-units/",
          de: "https://www.medical-videos.com/de/installation-und-bedienung-des-ies-3-rauchabsaugsystems-in-kombination-mit-elektrochirurgiegeraeten/",
        });
      },
      hyperlink_downloads_ies_webcast: () => {
        return "https://www.medical-videos.com/webcast-smoke-evacuation-system-ies-3/"
      }
    }
  };
};
